module.exports = __webpack_public_path__ + "img/payment.708e8847.png";